package com.tregz.tremenz.io.cloud

/** Firestore collections holding the video catalogue, shared by every target. */
enum class CloudPath {
    APERO,
    BISTRO,
    CLUB;

    override fun toString(): String = name.lowercase().replaceFirstChar {
        if (it.isLowerCase()) it.titlecase() else it.toString()
    }

    fun lowercase(): String = name.lowercase()
}
